import React from 'react';
import { useNavigate } from 'react-router-dom';

import { snackbar } from '@occc-app/design-system';
import { Change_Source, LocationAttributeCreate, LocationCreate } from '@occc/graphql';
import { useLocationCreateMutation } from '@occc-app/dataAccessLayer/location/mutations';

import LocationCreatePage from './LocationCreatePage';
import { LocationCreateFormData } from './types';

import { routeCreator } from '../utils';
import { LOCATION_ATTRIBUTE_VALUE } from '../constants';

export const LocationCreatePageContainer = () => {
  const navigate = useNavigate();
  const locationCreateMutation = useLocationCreateMutation(
    (values: LocationCreateFormData) => {
      const attributes: LocationAttributeCreate[] = [];
      if (values.attributes && values.attributes.length) {
        values.attributes.forEach((attr) => {
          attributes.push({ name: attr.toString(), value: LOCATION_ATTRIBUTE_VALUE.YES });
        });
      }
      const res: LocationCreate = {
        locationGroupUuids: values?.locationGroups?.map((group) => group?.uuid) || null,
        // brandSpecificLocationId value according to https://stuzo.atlassian.net/browse/OCST-6513
        brandSpecificLocationId: values.siteSystemConfiguration?.identifier,
        address: {
          ...values.address,
          state: values.address.state.id,
          geoLocation:
            values.address.geoLocation &&
            values.address.geoLocation.latitude &&
            values.address.geoLocation.longitude
              ? {
                  latitude: parseFloat(values.address.geoLocation.latitude.toString()),
                  longitude: parseFloat(values.address.geoLocation.longitude.toString()),
                }
              : undefined,
        },
        siteSystemConfiguration: values.siteSystemConfiguration
          ? [{ ...values.siteSystemConfiguration, mobileEnabled: true, loyaltyEnabled: true }]
          : [],
        attributes,
        changeSource: Change_Source.CommandCenter,
        timezone: values.timezone.name,
      };
      return res;
    },
    {
      onCompleted: (data) => {
        if (data.locationCreate) {
          snackbar.success('Location was created');
          navigate(routeCreator.generalDetails(data.locationCreate.uuid));
        }
      },
    },
  );

  return <LocationCreatePage locationCreate={locationCreateMutation} />;
};

export default LocationCreatePageContainer;
